/* form_renderer.module.js */

var angular = require("angular");
module.exports = angular.module("form_renderer", [
    "templatecache",
    "gl_textarea",
    "gl_textfield",
    "gl_checkbox",
    "gl_multi_select",
]);


/* Generated Dependencies */
module.exports.directive("glFormRenderer", require('././directives/gl_form_renderer.directive.js'));